import Section1 from "./Section1";

export default function Blog() {
  return (
    <div className="w-full lg:w-[100%] bg-[#0A0F1F] ">
      <div className="mx-auto  pt-20 lg:pt-20">
        <div className="flex flex-wrap gap-6">

          {/* Left Section - 100% width on large screens */}
          <div className="w-full lg:w-[100%]">
            <Section1 />
          </div>

        </div>
      </div>
    </div>
  );
}



// bg-gradient-to-br  from-black to-cyan-900